<template>
  <div class="legal-page py-5 mt-5">
    <div class="container mt-5 pt-5">
      <div class="legal-content">
        <h1 class="legal-title font-good-brush mb-4 text-center">
          Términos y Condiciones
        </h1>

        <p class="legal-updated mb-5 text-center">
          Última actualización: {{ lastUpdated }}
        </p>

        <section class="legal-section mb-5">
          <h2>1. Información general</h2>
          <p>
            Bienvenido/a a Fix Glass. Al acceder a este sitio web, realizar una compra,
            solicitar una reparación o contratar cualquiera de nuestros servicios, el usuario
            acepta los presentes Términos y Condiciones.
          </p>
          <p>
            Fix Glass se dedica a la venta de celulares, accesorios, repuestos, productos de
            tecnología en general y servicios de reparación técnica de dispositivos. Estos
            términos tienen como objetivo informar de manera clara las condiciones de compra,
            uso del sitio, garantías, cambios, devoluciones y servicios ofrecidos.
          </p>
        </section>

        <section class="legal-section mb-5">
          <h2>2. Productos, precios y disponibilidad</h2>
          <p>
            Los productos publicados en el sitio pueden incluir celulares, accesorios,
            dispositivos tecnológicos, repuestos y otros artículos relacionados. Las imágenes,
            descripciones y características son orientativas y pueden variar levemente según
            el modelo, partida, proveedor o disponibilidad.
          </p>
          <p>
            Los precios están expresados en pesos argentinos, salvo que se indique lo contrario.
            Fix Glass se reserva el derecho de modificar precios, promociones, financiación,
            descripciones o disponibilidad sin previo aviso. En caso de existir un error evidente
            en el precio o publicación, nos comunicaremos con el cliente antes de confirmar la
            operación.
          </p>
          <p>
            La disponibilidad de los productos está sujeta a stock. Si un producto abonado no
            se encontrara disponible, se ofrecerá al cliente una alternativa, la reprogramación
            de entrega o la devolución del importe abonado.
          </p>
          <p>
            Se aceptan devoluciones hasta 30 días posteriores a la compra, siempre que el
            producto se encuentre en las mismas condiciones en que fue entregado y con su
            embalaje original, salvo excepciones informadas al momento de la compra.
          </p>
        </section>

        <section class="legal-section mb-5">
          <h2>3. Compras y medios de pago</h2>
          <p>
            Para realizar una compra, el usuario deberá proporcionar información real, completa
            y actualizada. Fix Glass no se responsabiliza por demoras o inconvenientes derivados
            de datos incorrectos, incompletos o falsos ingresados por el cliente.
          </p>
          <p>
            Los medios de pago disponibles serán informados al momento de la compra. La
            aprobación del pago puede depender de entidades externas, bancos, plataformas de
            pago o medios de financiación.
          </p>
          <p>
            La compra se considera confirmada una vez acreditado el pago y validada la
            disponibilidad del producto o servicio solicitado.
          </p>
        </section>

        <section class="legal-section mb-5">
          <h2>4. Envíos, entregas y retiros</h2>
          <p>
            Los envíos, entregas o retiros estarán sujetos a las opciones disponibles informadas
            por Fix Glass. Los plazos de entrega son estimativos y pueden variar por cuestiones
            logísticas, disponibilidad del producto, ubicación del cliente o causas externas.
          </p>
          <p>
            El cliente es responsable de brindar correctamente los datos de envío o retiro. En
            caso de errores en la dirección, ausencia del receptor o imposibilidad de entrega,
            los costos adicionales podrán quedar a cargo del cliente.
          </p>
          <p>
            Al recibir un producto, el cliente deberá verificar su estado general, embalaje y
            funcionamiento inicial. Cualquier inconveniente deberá ser informado a la brevedad
            por los canales de contacto oficiales.
          </p>
        </section>

        <section class="legal-section mb-5">
          <h2>5. Reparaciones y servicio técnico</h2>
          <p>
            Fix Glass realiza servicios de diagnóstico, reparación y mantenimiento de celulares,
            dispositivos tecnológicos y equipos compatibles con nuestro servicio técnico.
          </p>
          <p>
            Antes de realizar una reparación, se podrá informar al cliente un diagnóstico,
            presupuesto estimado y plazo aproximado de trabajo. La reparación comenzará una vez
            aceptado el presupuesto por el cliente, salvo casos donde se haya pactado otra
            modalidad.
          </p>
          <p>
            El cliente declara ser titular o estar autorizado para entregar el equipo a reparar.
            También es responsable de realizar copia de seguridad de su información antes de
            dejar el dispositivo. Fix Glass no se responsabiliza por pérdida de datos, archivos,
            fotos, contactos, aplicaciones o información almacenada en el equipo.
          </p>
          <p>
            La garantía de reparación cubre únicamente la falla reparada y las piezas instaladas
            por Fix Glass, durante el plazo informado al momento del servicio. No cubre nuevas
            fallas, daños por golpes, humedad, mal uso, intervención de terceros, fallas
            preexistentes no relacionadas o problemas derivados del estado general del equipo.
          </p>
          <p>
            Los equipos deberán ser retirados dentro del plazo informado por Fix Glass una vez
            finalizada la reparación o comunicado el diagnóstico. En caso de abandono prolongado
            del equipo, Fix Glass podrá aplicar cargos por guarda o disponer medidas conforme a
            la normativa vigente.
          </p>
        </section>

        <section class="legal-section mb-5">
          <h2>6. Equipos usados o reacondicionados</h2>
          <p>
            En caso de comercializar equipos usados, reacondicionados o de segunda mano, se
            informará su condición general, estado estético, funcionamiento y garantía aplicable.
            El cliente acepta que este tipo de productos puede presentar marcas de uso propias
            de su condición, siempre que hayan sido informadas previamente.
          </p>
        </section>

        <section class="legal-section mb-5">
          <h2>7. Uso del sitio web</h2>
          <p>
            El usuario se compromete a utilizar este sitio de manera lícita, respetuosa y sin
            afectar su funcionamiento. Queda prohibido intentar vulnerar la seguridad del sitio,
            utilizarlo para fines fraudulentos, cargar información falsa o realizar acciones que
            puedan dañar la plataforma o a terceros.
          </p>
          <p>
            Fix Glass podrá suspender o cancelar operaciones cuando detecte uso indebido,
            fraude, datos falsos, operaciones sospechosas o incumplimiento de estos términos.
          </p>
        </section>

        <section class="legal-section mb-5">
          <h2>8. Propiedad intelectual</h2>
          <p>
            Todo el contenido del sitio, incluyendo textos, imágenes, logotipos, diseños,
            gráficos, fotografías, estructura visual y elementos de marca, pertenece a Fix Glass
            o a sus respectivos titulares. Queda prohibida su copia, reproducción, distribución
            o uso comercial sin autorización previa por escrito.
          </p>
        </section>

        <section class="legal-section mb-5">
          <h2>9. Protección de datos</h2>
          <p>
            Los datos personales solicitados serán utilizados únicamente para gestionar compras,
            reparaciones, consultas, envíos, facturación, garantías y comunicaciones relacionadas
            con los productos o servicios solicitados.
          </p>
          <p>
            Fix Glass se compromete a tratar la información del cliente de forma confidencial y
            a no compartirla con terceros, salvo que sea necesario para procesar pagos, envíos,
            servicios técnicos, obligaciones legales o requerimientos de autoridad competente.
          </p>
        </section>

        <section class="legal-section mb-5">
          <h2>10. Limitación de responsabilidad</h2>
          <p>
            Fix Glass no será responsable por daños indirectos, pérdida de información, lucro
            cesante, fallas causadas por terceros, mal uso de productos, incompatibilidades no
            informadas por el cliente o inconvenientes derivados de servicios externos como
            plataformas de pago, empresas de envío, bancos o proveedores.
          </p>
          <p>
            La responsabilidad de Fix Glass, cuando corresponda, se limitará al valor del
            producto adquirido o del servicio contratado.
          </p>
        </section>

        <section class="legal-section mb-5">
          <h2>11. Modificaciones de los términos</h2>
          <p>
            Fix Glass podrá actualizar o modificar estos Términos y Condiciones en cualquier
            momento. Las modificaciones entrarán en vigencia desde su publicación en el sitio.
            Se recomienda revisar esta página periódicamente.
          </p>
        </section>

        <section class="legal-section mb-5">
          <h2>12. Ley aplicable y jurisdicción</h2>
          <p>
            Estos términos se rigen por las leyes vigentes de la República Argentina. Cualquier
            controversia será resuelta ante los organismos o tribunales competentes que
            correspondan según la normativa aplicable y el domicilio del consumidor.
          </p>
        </section>

        <section class="legal-section mb-5">
          <h2>13. Contacto</h2>
          <p>
            Para consultas sobre estos Términos y Condiciones, compras, garantías o reparaciones,
            el cliente podrá comunicarse a través de nuestra página de
            <a href="/contacto">Contacto</a> o mediante los canales oficiales informados en el
            sitio web.
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
const lastUpdated = new Date().toLocaleDateString('es-AR', {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
});
</script>

<style scoped>
.legal-page {
  background: #050505;
  min-height: 100vh;
  color: #f5f5f5;
}

.legal-content {
  max-width: 1000px;
  margin: 0 auto;
  padding: 3rem 2rem;
  background: #0d0d0d;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);
}

.legal-title {
  font-size: 2.5rem;
  color: #ffffff;
  line-height: 1.2;
}

.legal-updated {
  font-size: 0.9rem;
  color: #9b9b9b;
}

.legal-section {
  padding-bottom: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.legal-section:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.legal-section h2 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--primary-color);
  margin-bottom: 1rem;
}

.legal-section p {
  font-size: 0.96rem;
  line-height: 1.75;
  margin-bottom: 1rem;
  color: #d7d7d7;
}

.legal-section a {
  color: var(--primary-color);
  text-decoration: underline;
  text-underline-offset: 4px;
  transition: color 0.2s ease;
}

.legal-section a:hover {
  color: #ffffff;
}

@media (max-width: 768px) {
  .legal-page {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .legal-content {
    padding: 2rem 1.25rem;
    border-radius: 18px;
  }

  .legal-title {
    font-size: 2rem;
  }

  .legal-section h2 {
    font-size: 1.1rem;
  }

  .legal-section p {
    font-size: 0.92rem;
    line-height: 1.65;
  }
}
</style>